/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { SpbSky2 } from '@/main/theme/default/colors/palette';
import { IAttrStyled } from '@/main/types/globalTypes';
import { colors } from '@theme/index';

export const ProgressBarStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `progress-bar ${className || ''}`,
}))`
    .progress-bar__title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
    }

    .progress-bar__title-container {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-right: 6px;
    }

    .progress-bar__title-right {
        display: flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        & > span {
            display: flex;
        }
    }

    .progress-bar__row {
        position: relative;
        height: 12px;
        border-radius: 9px;
        background-color: ${colors.borderColorDisabled};

        .progress-bar__row-active {
            position: absolute;
            max-width: 100%;
            height: 100%;
            border-radius: 9px;

            &.progress-bar__row-active_success {
                background-color: ${colors.backgroundColorSuccess};
            }

            &.progress-bar__row-active_warning {
                background-color: ${colors.backgroundColorWarning};
            }

            &.progress-bar__row-active_danger {
                background-color: ${colors.backgroundColorError};
            }

            &.progress-bar__row-active_spend {
                background-color: ${SpbSky2};
            }
        }
    }
`;

export const ProgressBarSharedInfoIcon = styled.img`
    display: flex;
`;

export const ProgressBarSpendInfoIcon = styled.img`
    display: flex;
`;
